/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PatchedPoorAiModel
 */
export interface PatchedPoorAiModel {
  /**
   *
   * @type {number}
   * @memberof PatchedPoorAiModel
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedPoorAiModel
   */
  name?: string;
  /**
   *
   * @type {UseCaseName}
   * @memberof PatchedPoorAiModel
   */
  readonly useCase?: UseCaseName;
  /**
   *
   * @type {number}
   * @memberof PatchedPoorAiModel
   */
  useCaseId?: number;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PatchedPoorAiModel
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PatchedPoorAiModel
   */
  technicalOwner?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedPoorAiModel
   */
  technicalInfo?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedPoorAiModel
   */
  datasetInfo?: string;
  /**
   *
   * @type {Date}
   * @memberof PatchedPoorAiModel
   */
  liveFrom?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof PatchedPoorAiModel
   */
  decomissionedOn?: Date | null;
}

/**
 * Check if a given object implements the PatchedPoorAiModel interface.
 */
export function instanceOfPatchedPoorAiModel(value: object): value is PatchedPoorAiModel {
  return true;
}

export function PatchedPoorAiModelFromJSON(json: any): PatchedPoorAiModel {
  return PatchedPoorAiModelFromJSONTyped(json, false);
}

export function PatchedPoorAiModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedPoorAiModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    useCase: json['use_case'] == null ? undefined : UseCaseNameFromJSON(json['use_case']),
    useCaseId: json['use_case_id'] == null ? undefined : json['use_case_id'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    technicalOwner: json['technical_owner'] == null ? undefined : json['technical_owner'],
    technicalInfo: json['technical_info'] == null ? undefined : json['technical_info'],
    datasetInfo: json['dataset_info'] == null ? undefined : json['dataset_info'],
    liveFrom: json['live_from'] == null ? undefined : new Date(json['live_from']),
    decomissionedOn: json['decomissioned_on'] == null ? undefined : new Date(json['decomissioned_on']),
  };
}

export function PatchedPoorAiModelToJSON(value?: Omit<PatchedPoorAiModel, 'id' | 'useCase'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    use_case_id: value['useCaseId'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    technical_owner: value['technicalOwner'],
    technical_info: value['technicalInfo'],
    dataset_info: value['datasetInfo'],
    live_from: value['liveFrom'] == null ? undefined : (value['liveFrom'] as any).toISOString().substring(0, 10),
    decomissioned_on:
      value['decomissionedOn'] == null ? undefined : (value['decomissionedOn'] as any).toISOString().substring(0, 10),
  };
}
